import {
    EDIT_ALERT_TYPE_SUPPORTED_OPEN_MODAL,
    EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_REQUEST,
    EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_RESULT,
} from 'Redux/actionTypes';

export const editAlertTypeSupportedOpenModal = (open, deviceModel, alertTypes) => ({
    type: EDIT_ALERT_TYPE_SUPPORTED_OPEN_MODAL,
    payload: { open, deviceModel, alertTypes }
})

export const editAlertTypeSupportedUpdateAlertTypesRequest = (data) => ({
    type: EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_REQUEST,
    payload: data
})

export const editAlertTypeSupportedUpdateAlertTypesResult = (data) => ({
    type: EDIT_ALERT_TYPE_SUPPORTED_UPDATE_ALERT_TYPES_RESULT,
    payload: { data }
})
